//@flow

import * as React from 'react';
import { Route, Switch, type Match, Router } from 'react-router-dom';
import AppContainer from '../components/AppContainer';
import RoutesEnum from '../constants/RoutesEnum';

type Props = {
    match: Match,
};

const AppRoutes = (props: Props): React.Node => {
    const { history } = props;
    return (
        <Router history={history}>
            <Switch>
                <Route path={RoutesEnum.LandingPage} component={AppContainer} />
            </Switch>
        </Router>
    );
};

export default AppRoutes;
